import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { AddEditScanMachineComponent } from '../add-edit-scan-machine/add-edit-scan-machine.component';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { MiscService } from '../../_service/misc.service';
import { MatDialog } from '@angular/material/dialog';
import { formatDate } from '@angular/common';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-scan-machine-list',
  templateUrl: './scan-machine-list.component.html',
  styleUrls: ['./scan-machine-list.component.css']
})
export class ScanMachineListComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  perpage: number = 25; machineList: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true; openmodal = '';
  pageSizeOptions = [10, 25, 50, 100]; pageIndex: number = 0; loaded: boolean = false;
  machine = ''; submitted: boolean = false;
  constructor(private dialog: MatDialog, private sharedapi: SharedService, public miscapi: MiscService) { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.loadMachineList(0, this.perpage);
  }

  async loadMachineList(pageIndex, perpage) {
    this.machineList = [];
    this.paginator.pageIndex = pageIndex;
    let qString = 'machine=' + this.machine;
    this.loading = true; this.loaded = false;
    await this.miscapi.getMachineList(this.paginator.pageIndex, perpage, qString).subscribe((data: any) => {
      this.length = parseInt(data.totaldata);
      this.loading = false;
      this.loaded = true;
      if (data.status) {
        this.machineList = data.data;
      } else {
        this.machineList = [];
      }
    }, error => {
      this.loading = false;
      this.loaded = true;
      this.sharedapi.checkError(error);
    });
  }

  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadMachineList(event.pageIndex, event.pageSize);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadMachineList(event.pageIndex, event.pageSize);
  }

  resetFilters() {
    this.machine = '';
    this.loadMachineList(0, 25);
  }

  openMachineDialog(machine) {
    const dialogRef = this.dialog.open(AddEditScanMachineComponent, {
      width: '35%',
      height: '45%',
      data: machine
    });
  }

  //=====Export List=====//
  exportMachineList() {
    if (this.machineList.length > 0) {
      let data = [];
      let titles = ['Machine Name', 'Created Date'];

      data.push(titles);

      for (let key in this.machineList) {
        let extData = [this.machineList[key].name, formatDate(this.machineList[key].created_at * 1000, 'dd MMM, yyyy hh:mm aa', 'en-US')];
        data.push(extData)
      }
      let ws = XLSX.utils.aoa_to_sheet(data);
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      let utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      XLSX.writeFile(wb, 'machinelist_' + utc + '.xlsx');
    } else {
      this.sharedapi.presentToast('No Machine Data found!');
    }
  }


}
